module.exports = __webpack_public_path__ + "img/b26832b.png";